import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LanguageService } from '../../core/services/language.service';

export interface SocialLink {
  icon: string;
  link: string;
  _id: string;
}

export interface QuickLink {
  title?: string;
  title_en?: string;
  title_ar?: string;
  url?: string;
  link?: string;
  _id?: string;
}

export interface Policy {
  label?: string;
  label_en?: string;
  label_ar?: string;
  url?: string;
  _id?: string;
}

export interface ContactInfo {
  email?: string;
  phoneNumber?: string[];
  address?: string;
  address_en?: string;
  address_ar?: string;
}

export interface Logo {
  public_id?: string;
  secure_url?: string;
}

export interface FooterData {
  _id?: string;
  contactInfo?: ContactInfo;
  logo?: Logo;
  socialLinks?: SocialLink[];
  title?: string;
  title_en?: string;
  title_ar?: string;
  description?: string;
  description_en?: string;
  description_ar?: string;
  copyright?: string;
  copyright_en?: string;
  copyright_ar?: string;
  quickLinks?: QuickLink[];
  policies?: Policy[];
}

export interface FooterResponse {
  footer: FooterData | FooterData[];
}

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private baseUrl = environment.api.baseUrl;

  constructor(
    private http: HttpClient,
    private languageService: LanguageService,
  ) {}

  getFooterData(): Observable<FooterResponse> {
    const currentLanguage = this.languageService.getCurrentLanguage();

    // إضافة headers مباشرة في السيرفيس
    const headers = {
      'Accept-Language': currentLanguage,
      'Content-Language': currentLanguage,
      'X-Language': currentLanguage,
    };

    console.log('🦶 FooterService - getFooterData() called with:');
    console.log('  - language:', currentLanguage);
    console.log('  - headers:', headers);

    return this.http.get<FooterResponse>(`${this.baseUrl}/footer`, { headers });
  }
}
